export default __webpack_public_path__ + "static/media/article.fc0b7ccb.png";